import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPage = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Nura Health</title>
        <meta name="description" content="Nura Health privacy policy. How we collect, use, and protect your personal and health information under the Privacy Act 1988." />
        <link rel="canonical" href="https://nurahealth.com.au/privacy" />
      </Helmet>
      <div style={{ width: '100%', height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
        <iframe
          src="/privacy.html"
          style={{ width: '100%', height: '100%', border: 'none', margin: 0, padding: 0 }}
          title="Privacy Policy"
        />
      </div>
    </>
  );
};

export default PrivacyPage;
